








import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'CartIcon',
  computed: {
    cartItemCount() {
      return this.$store.getters['cart/cartItemCount'] || 0
    },
    showBadge() {
      return !!this.cartItemCount
    },
  },
})
